import React from 'react';

export const ReleaseDocumentIcon = ({ color = '#fff', ...restProps }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      {...restProps}
    >
      <path
        d="M16.0039 4H18.0039C18.5343 4 19.043 4.21071 19.4181 4.58579C19.7932 4.96086 20.0039 5.46957 20.0039 6V20C20.0039 20.5304 19.7932 21.0391 19.4181 21.4142C19.043 21.7893 18.5343 22 18.0039 22H6.00391C5.47347 22 4.96477 21.7893 4.58969 21.4142C4.21462 21.0391 4.00391 20.5304 4.00391 20V6C4.00391 5.46957 4.21462 4.96086 4.58969 4.58579C4.96477 4.21071 5.47347 4 6.00391 4H8.00391"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0039 2H9.00391C8.45162 2 8.00391 2.44772 8.00391 3V5C8.00391 5.55228 8.45162 6 9.00391 6H15.0039C15.5562 6 16.0039 5.55228 16.0039 5V3C16.0039 2.44772 15.5562 2 15.0039 2Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.00391 11H16.0039" strokeLinecap="round" />
      <path d="M8.00391 14H13.0039" strokeLinecap="round" />
      <path d="M8.00391 17H16.0039" strokeLinecap="round" />
    </svg>
  );
};
